import Vue from 'vue'
import Router from 'vue-router'
import iView from 'iview'
import util from '../utils'
import routers from './routers'
import store from '../store'
import config from '../config'
Vue.use(Router)
const RouterConfig = {
    mode: 'hash', //history hash
    //   base: config.root,
    routes: routers
}
const router = new Router(RouterConfig)
var currentRouter = null
router.toReferrer = function() {
    if (!currentRouter) {
        router.push({ path: '/' })
    } else {
        router.push({ path: currentRouter })
    }
}
let userinfo = JSON.parse(localStorage.getItem("userinfo"));
router.beforeEach((to, from, next) => {
    iView.LoadingBar.start()
    const webtitle = to.meta.title ? to.meta.title + '-' + config.siteName : config.siteName
    util.title(webtitle)
    if (to.meta.logined === false) {
        next()
    } else if (to.meta.logined === true) {
        window.currentRouter = to.path + "?id=" + to.query.id + "&key=" + to.query.key;
    } else {
        if(userinfo && userinfo.typeCode == 'Studio' && userinfo.isUsing!==null && (userinfo.isUsing=='N' || userinfo.isUsing=='S')) {
            window.currentRouter = '/personal';
            next()
        } else {
            window.currentRouter = to.path;
        if (to.path == "/emailsuccess") {
            window.routeReady = true;
        } else {
            window.routeReady = window.routeReady;
        }
        if (window.routeReady) {
            if (window.routeReady) {
                if (to.path.indexOf("/publish")>-1 && !to.query.articleID && store.state.userinfo.suspensionType=='Y') {
                    iView.Modal.warning({
                        title: '禁止发表',
                        content: '您的账号已暂停，禁止发表内容',
                        onOk: () => {
                            iView.LoadingBar.finish()
                            // if(window.currentRouter.indexOf("/publish")>-1){
                            //     router.replace(`/`)
                            // }
                        }
                    })
                }else {
                    next()
                }
            }
        }
        }
    }

})
router.afterEach(() => {
    iView.LoadingBar.finish()
    window.scrollTo(0, 0)
    var currentRoutePath = router.currentRoute.path
    store.commit('breadcrumb', currentRoutePath)
    store.commit('menu', router.currentRoute)
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js